const prefix = 'CAMPAIGN_ACTIONS_';
export const GET_UPCOMING_CAMPAIGN = `${prefix}GET_UPCOMING_CAMPAIGN`;
export const GET_PAST_CAMPAIGN = `${prefix}GET_PAST_CAMPAIGN`;
export const UPCOMING_CAMPAIGN_SUCCESS = `${prefix}UPCOMING_CAMPAIGN_SUCCESS`;
export const PAST_CAMPAIGN_SUCCESS = `${prefix}PAST_CAMPAIGN_SUCCESS`;
export const DELETE_CAMPAIGN = `${prefix}DELETE_CAMPAIGN`;
